import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/shared/guards/auth.guard';
import { PermissionGuard } from 'src/app/shared/guards/permission.guard';
import { PermissionConstants } from 'src/app/constants/permissions';

/**
 * Human-facing kiosk admin routes (PLAN.md §4, §13 — "Human pages live outside /kiosk").
 * Not wired into app-routing.module.ts by this change — see the kiosk-admin "Report" for
 * the exact snippet and where it goes. Mirrors analytics.routes.ts's lazy standalone pattern.
 */
// Every route admits CanAuthorizeKioskDevices OR CanManageKioskDevices OR IsGlobalAdmin (PermissionConstants.KioskAccess);
// CanManageProjects alone grants nothing (backend KioskAccessScope).
export const KIOSK_ADMIN_ROUTES: Routes = [
  {
    path: 'kiosk-authorize',
    pathMatch: 'full',
    loadComponent: () =>
      import('./kiosk-code-entry/kiosk-code-entry.component').then((m) => m.KioskCodeEntryComponent),
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      requiredPermission: [...PermissionConstants.KioskAccess],
    },
  },
  {
    path: 'kiosk-authorize/:code',
    loadComponent: () =>
      import('./kiosk-authorize/kiosk-authorize.component').then((m) => m.KioskAuthorizeComponent),
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      requiredPermission: [...PermissionConstants.KioskAccess],
    },
  },
  {
    path: 'kiosk-devices',
    loadComponent: () =>
      import('./kiosk-device-list/kiosk-device-list.component').then((m) => m.KioskDeviceListComponent),
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      requiredPermission: [...PermissionConstants.KioskAccess],
    },
  },
];
